import { Injectable, signal } from '@angular/core';
import { IIdAndName } from '../../../../core/interfaces/IIdAndName';

@Injectable({
  providedIn: 'root'
})
export class DatevStore {

  public readonly datevAccounts = signal<IIdAndName<number>[]>([]);
}
